var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 607.5 607.5",
    enableBackground: "new 0 0 607.5 607.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 460.2,
    cy: 487.9,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 406.8,
    cy: 501.6,
    r: 29.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M117.5,301.3l7.2,15.9l-0.1,0c0.2,0.4,0.5,0.8,0.7,1.3c5.2,8.8,18.2,16,19.9,25.7 c2.2,12.6-3.3,28-1.4,41.6c3.1,21,12.1,41.2,27.5,56.2c16.3,15.8,33.7,18.2,54.2,25.1c7.6,2.6,13.2,8.9,20.6,13.3 c10.3,6.2,22.4,10.4,34,13.1c22.9,5.3,48.8,6.1,70.5-4c7.8-3.6,15-8.6,20.9-14.9c5.1-5.4,7.5-15.9,12.4-20.1 c8.2-7,18.1-4.2,28.2-8.4c0.5-0.2,1.6-0.6,2.9-1.1c3.8-1.3,8.1-0.3,10.6,2.8c3.2,3.9,8.6,5.9,14.3,4.2c4.2-1.3,7.5-4.7,8.7-8.9 c1.2-4.5,0.2-8.8-2.3-12c-1.5-1.9-1.5-4.7,0.2-6.5c4.1-4.6,7.4-9.8,10-15.6c3.5-8,2.3-19.7,6.8-26.9c5.8-9.3,15.2-14.9,20.5-25.5 c5-9.9,7.8-20.6,9.2-31.5l0.9-17c-0.2-5.3-0.7-10.5-1.9-15.7c-1.2-5.7-5.3-12-5.9-17.5c-0.8-7.2,3-11.4,5-17.7 c6.8-22.1,5.3-46.1-7.5-65.9c-5.4-8.4-13.2-12.4-19.7-19.2c-5.6-5.9-7.2-11.6-11.6-19.7c-9.9-17.9-26.5-33-45.9-39.7 c-9.8-3.4-18.7-2.3-28.6-3.9c-11.7-1.9-18.9-12.2-28.9-17.9c-34.7-19.9-88.5-20.3-118,9.6c-9.8,10-12.3,18.2-25.9,23.2 c-9.8,3.6-18.8,6.7-27.2,13.2c-8,6.3-14.2,14-18.8,23.1c-5.3,10.7-0.8,24.4-8.3,34.2c0,0-0.1,0.1-0.1,0.1 c-6.5,8.3-15.6,13.3-21.8,22.1c-6.9,9.8-11.6,21-14.1,32.6C110.9,266.4,111.9,284.6,117.5,301.3z M275.1,399.7 c10.4,6.4,23.9,7.4,35.8,7.3c9.4-0.1,23.7-0.1,31.4-6.5c5-4.1,12.1,3,7.1,7.1c-9.7,8-24.4,9.1-36.4,9.4c-14.3,0.4-30.5-1-43-8.6 C264.5,405,269.5,396.3,275.1,399.7z M175.5,303.5c0.2-0.6,0.3-1.3,0.5-1.9c7.1-24,30.1-40.7,55-40.7c25.8,0,47.7,17,55.1,40.4 c15.4,0,30.8,0.2,46.2,0.5c7.2-23.6,29.2-40.9,55.2-40.9c35.8,0,61.4,33.7,56.9,66.5c-0.9,6.8-3.2,13.6-6.9,20.1 c-10.2,17.7-29.5,28.9-50,28.9c-30.9,0-56.3-24.5-57.7-55.1c-13.7-0.4-27.4-0.7-41.1-0.8c-1,31-26.5,55.9-57.7,55.9 C193.8,376.4,166.4,339,175.5,303.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M231.1,282.1c21,0,38.4,18.7,36.2,39.7c-1.9,18.3-17.6,33.3-36.2,33.3c-18.7,0-34.8-14.9-36.3-33.3 c-0.1-1.3-0.1-2.7-0.1-4.1C195.3,298.4,211.9,282.1,231.1,282.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M387.6,282.1c20.6,0,37.8,18,36.3,38.6c-1.3,18.7-17.4,34.4-36.3,34.4c-1.2,0-2.4-0.1-3.6-0.2 c-19.3-1.9-34.3-19.8-32.3-39.2C353.6,297.7,369.1,282.1,387.6,282.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.808dc8263792f9cb0dec1c2424b36ba0.svg";
export { ForwardRef as ReactComponent };